import { Directive, ElementRef, HostListener } from '@angular/core';

/**
 * Diretiva que remove os caracteres especiais do campo
 */
@Directive({
    // tslint:disable-next-line:directive-selector
    selector: 'input[onlyNumbers]'
})
export class OnlyNumbersDirective {

    constructor(private _el: ElementRef) { }

    @HostListener('input', ['$event']) onInputChange(event) {
        const initalValue = this._el.nativeElement.value;
        this._el.nativeElement.value = initalValue.replace(/[^0-9 ]/g, '');
        if (initalValue !== this._el.nativeElement.value) {
            event.stopPropagation();
        }
    }

}